const definePath = (imageSrc: string): string => {
  if (imageSrc?.includes("base64")) {
    return imageSrc;
  }
  // return `${process.env.BASE_URL}/${process.env.IMAGE_FOLDER}/${imageSrc}`;
  return imageSrc;
};

export default definePath;
